import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import AllProduct from '@/components/AllProduct'
import Intro from '@/components/Intro'
import Complaint from '@/components/Complaint'
import ComplaintList from '@/components/ComplaintList'
import ComplaintDetails from "@/components/ComplaintDetails"
import Success from "@/components/Success"
import AllGame from "@/components/AllGame"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }, {
      path: '/product',
      name: 'allProduct',
      component: AllProduct
    }, {
      path: '/allGame',
      name: 'allGame',
      component: AllGame
    }, {
      path: '/intro',
      name: 'intro',
      component: Intro
    }, {
      path: '/complaint',
      name: 'complaint',
      component: Complaint
    }, {
      path: '/complaintList',
      name: 'complaintList',
      component: ComplaintList
    }, {
      path: '/complaintDetails',
      name: 'complaintDetails',
      component: ComplaintDetails
    }, {
      path: '/success',
      name: 'success',
      component: Success
    }, {
      path: '/static'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js